import { Injectable } from "@angular/core";
import { AppConfig, AppConfigService } from "src/services/app-config.service";
import { AuthService } from "src/auth/auth.service";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { VisitTypeDto } from "src/DTOs/Organisations/Models/VisitTypeDto";
import { HttpClient } from "@angular/common/http";
import { ProcedureProtocolMessageDTO } from "src/DTOs/Organisations/Models/ProcedureProtocolMessageDTO";
import { SimpleDialogComponent } from "src/app/components/simple-dialog/simple-dialog.component";
import { MatDialog } from "@angular/material";
import { tap } from "rxjs/operators";

@Injectable()
export class VisitTypeService{
    private appConfig = new AppConfig();
    public visitTypes:VisitTypeDto[] =[]; 
    public dialogLatch=0;

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService,
        private authService: AuthService,
        private dialog: MatDialog,
      ) {
        this.appConfig = this.appConfigService.getConfig();           
      }

    initVistTypes() {
        this.getVisitTypes()
            .subscribe((vt) => {
                this.visitTypes = vt;
            },
                (err) => {
                    console.error(err, "Can not initiate visitTypeService.");
                }

            );
    }

      getVisitTypes(unassignedOnly?: boolean): Observable<VisitTypeDto[]> {
        let url: string =
          this.appConfig.oc_api_url + environment.oc_api_visit_types_url;
        if (unassignedOnly) {
          url += "?unassignedOnly=true";
        }
        if (environment.debug_mode) {
          console.log("getVisitTypes: " + url);
        }
        return this.http.get<VisitTypeDto[]>(url)
        .pipe(tap((response) => { this.visitTypes = response; }));
      }
    
    updateVisitTypes(visitTypes: VisitTypeDto[]) {
        
        let url: string =
            this.appConfig.oc_api_url + environment.oc_api_visit_types_url;

        if (environment.debug_mode) {
            console.log("getVisitTypes: " + url);
        }
        return this.http.post<VisitTypeDto[]>(url, visitTypes)
            .pipe(tap((response) => { this.visitTypes = response; }));
    }
    
      getVisitTypeMessages(visitTypeId: string): Observable<ProcedureProtocolMessageDTO[]> {
           
        let url: string =
          `${this.appConfig.oc_api_url}${environment.oc_api_procedure_protocols_url}visittypemessages/${visitTypeId}`;
    
        return this.http.get(url) as any;
      }

    removeItemCode(item: string, vt: VisitTypeDto): void {
        const visitType = this.visitTypes.find(v => v.id === vt.id);
        if (visitType) {
            visitType.itemCodes = visitType.itemCodes.filter(x => x != item);
            this.updateVisitTypes(this.visitTypes)
            .subscribe(()=>{}, (err)=>{console.error(err)});
        }
    }

    validateItemCodes(value: string, targetVisitType: VisitTypeDto) {
        const items = value.split(",")
            .filter(x => x && x.length > 0) // remove empty
            .map(x => x.trim()) // trim
            .filter((v, i, s) => s.findIndex(x => x.toLowerCase() == v.toLowerCase()) == i); // de-dupe the input

        const lowerItems = items.map(x => x.toLowerCase());
        var duplicates = lowerItems.filter(d => this.visitTypes.filter(x => x !== targetVisitType).some(e => e.itemCodes.some(x => d == x.toLowerCase())));
        return { duplicates, items };
    }


      showMoveDialog(duplicates: string[],
        targetVisitType: VisitTypeDto,
        itemsToAdd: string[],
        callback: (result: "yes" | "no", items: string[], duplicateItems: string[]) => void) {
    
        const lowerItems = itemsToAdd.map(x => x.toLowerCase());
        this.dialogLatch++;
        const dialogRef = this.dialog.open(SimpleDialogComponent, {
          width: '450px',
          maxWidth: '100vw',
          data: {
            message: duplicates.length > 1 ?
              `The item codes ${duplicates.join(", ")} are already in use in other visit types. Move them to ${targetVisitType.name}?`
              :
              `The item code ${duplicates[0]} is already in use in another visit type. Move it to ${targetVisitType.name}?`,
            button: 2
          }
        });
        dialogRef.afterClosed().subscribe(x => {
          if (x.result == "yes") {
            this.visitTypes.forEach(x => x.itemCodes = x.itemCodes.filter(y => !lowerItems.includes(y.toLowerCase())));
          } else {
            itemsToAdd = itemsToAdd.filter(x => !duplicates.includes(x.toLowerCase()));
          }
          this.dialogLatch--;
          callback(x.result, itemsToAdd, duplicates);
        });
      }

      showNotAddedDialog(duplicates: string[],
        callback: () => void) {
        this.dialogLatch++;
        const dialogRef = this.dialog.open(SimpleDialogComponent, {
          width: '450px',
          maxWidth: '100vw',
          data: {
            message: duplicates.length > 1 ?
              `The item codes ${duplicates.join(", ")} are already listed in this visit type and were therefore not added`
              :
              `The item code ${duplicates[0]} is already listed in this visit type and was therefore not added`,
            button: 0
          }
        });
        dialogRef.afterClosed().subscribe(x => {
          this.dialogLatch--;
          callback();
        });
    }
    
    processAddItemCode(items: string[], visitType: VisitTypeDto, input: HTMLInputElement, notAdded: string[]) {
        const lowerCodes = visitType.itemCodes.map(x => x.trim().toLowerCase());
        const dupes = items.filter(x => lowerCodes.includes(x.toLowerCase()));
        const deduped = items.filter(x => !dupes.includes(x));
        if (dupes.length) {
          this.showNotAddedDialog(dupes, () => {
              visitType.itemCodes = [...visitType.itemCodes, ...deduped];
              const vT = this.visitTypes.find(v=>v.id===visitType.id);
              vT.itemCodes = [...visitType.itemCodes];
            });
        } else {
          visitType.itemCodes = [...visitType.itemCodes, ...deduped];
          const vT = this.visitTypes.find(v=>v.id===visitType.id);
          vT.itemCodes = [...visitType.itemCodes];
        }
    
        // Reset the input value
        if (input) {
          input.value = notAdded && notAdded.length ? notAdded.join(",") : '';
        }

        this.updateVisitTypes(this.visitTypes)
        .subscribe(()=>{}, (err)=>{console.error(err)});
    }

  
    
}
